import FrontpageStyles from './Frontpage.module.css';
import FrontBookCover from "./photos/BookDecorWebP/BookofAbdul_FrontBookCover.webp";
import BackBookCover from "./photos/BookDecorWebP/BookofAbdul_BackBookCover.webp";
import OpenBookCover from "./photos/BookDecorWebP/BookofAbdul_BookCover.webp";
import IndividualPage from "./photos/BookDecorWebP/BookofAbdul_Pages(Individual).webp";

function Home() {

   // console.debug("Home.");
    const front = 
        { 
            title: "FrontBookCover",
            photo: FrontBookCover
        };

    const back = 
        {
            title: "BackBookCover",
            photo: BackBookCover
        };

    const open = 
        {
            title: "OpenBookCover",
            photo: OpenBookCover
        };

    const page = 
        {
            title: "IndividualPage",
            photo: IndividualPage,
            id: 2
        };

    const pagenums = 13;

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open" style={{opacity: "0.0"}}>
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages" style={{opacity: "0.0"}}>
                <ul className={FrontpageStyles["BoA-individual-pages"]}> 
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-bookpage-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div id="BoA-book-cover-front">
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
        </section>
    );
}

export default Home;